import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const ProgressBarSvg = () => (
  <svg width='46' height='5' viewBox='0 0 46 5' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.46777 2.27536C1.46777 1.17079 2.3632 0.27536 3.46777 0.27536H43.4678C44.5723 0.27536 45.4678 1.17079 45.4678 2.27536C45.4678 3.37993 44.5723 4.27536 43.4678 4.27536H3.46777C2.3632 4.27536 1.46777 3.37993 1.46777 2.27536Z'
      fill='#F3EBFF'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.608398 2.27536C0.608398 1.17079 1.50383 0.27536 2.6084 0.27536H12.6084C13.713 0.27536 14.6084 1.17079 14.6084 2.27536C14.6084 3.37993 13.713 4.27536 12.6084 4.27536H2.6084C1.50383 4.27536 0.608398 3.37993 0.608398 2.27536Z'
      fill='#8B33FF'
    />
  </svg>
);

export const ProgressBarColorIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ProgressBarSvg} {...props} />
);
